import { AxiosService } from '../config/config'
import { Endpoints } from '../config/endpoints'
import { IPayload } from '../../models/Global'
import {
  IGetShiftPreferencesAdvancedCanMuteBusinessesParams,
  IGetShiftPreferencesAdvancedParams,
  IMuteUnmuteShiftPreferencesAdvancedParams,
  IPauseResumeShiftPreferencesAdvancedParams,
  IPutShiftPreferencesAdvancedParams,
  IShiftPreferencesAdvanced,
  IShiftPreferencesAdvancedBusiness,
} from '../../models/ShiftPreferencesAdvanced'

export class ShiftPreferencesAdvancedApi {
  constructor(private axios: AxiosService) {}

  getShiftPreferencesAdvanced = async (params: IGetShiftPreferencesAdvancedParams) => {
    const response = await this.axios.get<IPayload<IShiftPreferencesAdvanced[]>>(
      Endpoints.getShiftPreferencesAdvanced,
      params
    )
    return response
  }

  getShiftPreferencesAdvancedCanMuteBusinesses = async (
    params: IGetShiftPreferencesAdvancedCanMuteBusinessesParams
  ) => {
    const response = await this.axios.get<IPayload<IShiftPreferencesAdvancedBusiness[]>>(
      Endpoints.getShiftPreferencesAdvancedCanMuteBusinesses,
      params
    )
    return response
  }

  putShiftPreferencesAdvanced = async (id: number, params?: IPutShiftPreferencesAdvancedParams) => {
    const response = await this.axios.put<IPayload<IShiftPreferencesAdvanced>>(
      Endpoints.putShiftPreferencesAdvanced(id),
      params
    )
    return response
  }

  pauseShiftPreferencesAdvanced = async (params: IPauseResumeShiftPreferencesAdvancedParams) => {
    const response = await this.axios.post<IPayload<IShiftPreferencesAdvanced>>(
      Endpoints.pauseShiftPreferencesAdvanced,
      params
    )
    return response
  }

  resumeShiftPreferencesAdvanced = async (params: IPauseResumeShiftPreferencesAdvancedParams) => {
    const response = await this.axios.post<IPayload<IShiftPreferencesAdvanced>>(
      Endpoints.resumeShiftPreferencesAdvanced,
      params
    )
    return response
  }

  shiftPreferencesAdvancedMuteBusiness = async (
    params: IMuteUnmuteShiftPreferencesAdvancedParams
  ) => {
    const response = await this.axios.post<IPayload<IShiftPreferencesAdvanced>>(
      Endpoints.shiftPreferencesAdvancedMuteBusiness,
      params
    )
    return response
  }

  shiftPreferencesAdvancedUnmuteBusiness = async (
    params: IMuteUnmuteShiftPreferencesAdvancedParams
  ) => {
    const response = await this.axios.post<IPayload<IShiftPreferencesAdvanced>>(
      Endpoints.shiftPreferencesAdvancedUnmuteBusiness,
      params
    )
    return response
  }
}
